import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import {
  BUYING_STORE_ID,
  DO_NOT_SHIP,
  DO_NOT_SHIP_REASONS,
  PORTAL_PURCHASE
} from "MODULES/PurchaseOrders/constants";
import {
  BUYER_CREDIT_PCT,
  CARRIER,
  COMPANY,
  COMPANY_ID,
  CONTACT_ID,
  FOB,
  PAYMENT_TERMS,
  SHIP_TO_SHIPPING_METHOD,
  SHIP_TO_TYPE,
  SHIPPING_METHOD
} from "APP_ROOT/constants";
import { BUYER_ID } from "MODULES/users/constants";
import { WEBSITE } from "MODULES/companies/constants";

export default function validate(values, props) {
  return validator(values, v => {
    v
      .validate(
        BUYER_ID,
        BUYER_CREDIT_PCT,
        BUYING_STORE_ID,
        COMPANY_ID,
        CONTACT_ID,
        SHIP_TO_TYPE,
        PAYMENT_TERMS,
        FOB
      )
      .satisfies(rules.required);

    if (values.ship_to_type === DO_NOT_SHIP) {
      v.validate("_error").satisfies(() => {
        if (!DO_NOT_SHIP_REASONS.some(field => values[field])) {
          return "At least 1 DO NOT SHIP REASON selection is required";
        }

        return null;
      });
    } else {
      v.validateChild(SHIP_TO_SHIPPING_METHOD, shippingForm => {
        shippingForm
          .validate(CARRIER, SHIPPING_METHOD)
          .satisfies(rules.required);
      });
    }

    if (values.contact_id === PORTAL_PURCHASE) {
      v.validateChild(COMPANY, companyForm => {
        companyForm.validate(WEBSITE).satisfies(rules.required);
      });
    }

    if (props.company) {
      v
        .validate(COMPANY_ID)
        .satisfies(() => rules.validateCompanyStatus(props.company));
    }
  });
}



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/ManagedRepairOrders/CreateManagedRepair/validate.js